/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: "/login",
    name: "Login",
    view: "Login"
  },
  {
    path: "/dashboard",
    // Relative to /src/views
    view: "Dashboard"
  },
  {
    path: "/user-profile",
    name: "User Profile",
    view: "UserProfile"
  },
  {
    path: "/crm",
    name: "Crm",
    view: "CRM"
  },
  {
    path: "/formulier",
    name: "Formulier",
    view: "Form"
  },
  {
    path: "/formulieren",
    name: "Formulieren",
    view: "Forms"
  },
  {
    path: "/formulieren/edit",
    name: "Formulieren aanpassen",
    view: "EditFormTemplate"
  },

  {
    path: "/settings",
    name: "Settings",
    view: "Settings"
  },
  {
    path: "/objecten",
    name: "Objecten",
    view: "Objecten"
  },
  {
    path: "/object",
    name: "Object",
    view: "Object"
  },
  {
    path: "/contracten",
    name: "Contracten",
    view: "Contracten"
  },
  {
    path: "/contract",
    name: "Contract",
    view: "Contract"
  },
  {
    path: "/typography",
    view: "Typography"
  },
  {
    path: "/icons",
    view: "Icons"
  },
  {
    path: "/maps",
    view: "Maps"
  },
  {
    path: "/notifications",
    view: "Notifications"
  }
];
